/**
 * Outbound-fetch timeout settings (milliseconds).
 *
 * Background (CON-8339): when the GraphQL/Alexandria upstream stalls — accepts
 * the connection but never (or too slowly) responds — an SSR render could run
 * for minutes because nothing bounded it. undici's global dispatcher only had a
 * `connect` timeout, and the Apollo fetch path (fetchWithRetry) passed no
 * AbortSignal. These helpers resolve the timeouts that now bound a stalled
 * upstream at two layers:
 *
 *   - getGraphqlFetchTimeoutMs(): the precise per-request AbortSignal timeout
 *     applied in fetchWithRetry (the Apollo/GraphQL fetch path). Read from a
 *     public (NEXT_PUBLIC_) var so the same value applies on the server at
 *     runtime and in the browser bundle (inlined at build).
 *
 *   - getServerOutboundTimeoutMs(): the undici global-dispatcher headers/body
 *     timeout — a broader, server-only backstop covering ALL outbound fetches
 *     (GraphQL, Contentful, geo, images, Next data fetches). Defaults slightly
 *     higher than the GraphQL abort so the precise, classified GraphQL timeout
 *     wins for GraphQL calls and the backstop only catches everything else.
 *
 * Both are env-tunable so they can be adjusted — or disabled — without a code
 * change. A value of `0` (or any non-positive value) DISABLES the timeout,
 * restoring the previous unbounded behaviour; a missing/non-numeric value falls
 * back to the default.
 */

export const DEFAULT_GRAPHQL_FETCH_TIMEOUT_MS = 25_000;
export const DEFAULT_SERVER_OUTBOUND_TIMEOUT_MS = 30_000;

const parseTimeoutMs = (raw, fallback) => {
  if (raw == null || raw === '') return fallback;
  const n = Number(raw);
  if (!Number.isFinite(n)) return fallback;
  // 0 (or any non-positive value) disables the timeout.
  return n <= 0 ? 0 : n;
};

export const getGraphqlFetchTimeoutMs = () =>
  parseTimeoutMs(
    process.env.NEXT_PUBLIC_GRAPHQL_FETCH_TIMEOUT_MS,
    DEFAULT_GRAPHQL_FETCH_TIMEOUT_MS
  );

export const getServerOutboundTimeoutMs = () =>
  parseTimeoutMs(
    process.env.SERVER_OUTBOUND_FETCH_TIMEOUT_MS,
    DEFAULT_SERVER_OUTBOUND_TIMEOUT_MS
  );
